import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GdoVehicleDetailWebviewComponent } from './gdo-vehicle-detail-webview/gdo-vehicle-detail-webview.component';
import { GdoWebviewComponent } from './gdo-webview.component';
import { GdoPurchaseSubscriptionWebviewComponent } from './gdo-purchase-subscription-webview/gdo-purchase-subscription-webview.component';
import { GdoContactSubscriptionWebviewComponent } from './gdo-contact-subscription-webview/gdo-contact-subscription-webview.component';
import { GdoBillingHistoryWebviewComponent } from './gdo-billing-history-webview/gdo-billing-history-webview.component';
import { GdoAddNewPaymentOptionsComponent } from '../gdo-desktop/gdo-payment/gdo-payment-components/gdo-payment-options/gdo-add-new-payment-options/gdo-add-new-payment-options.component';
import { GdoBraintreeIntegrationComponent } from '../gdo-desktop/gdo-payment/gdo-payment-components/gdo-braintree-integration/gdo-braintree-integration.component';

const routes: Routes = [
  {
    path: '',
    component: GdoWebviewComponent,
    children: [
      {
        path: '',
        component: GdoVehicleDetailWebviewComponent,
      },
      {
        path: 'purchase-subscription',
        component: GdoPurchaseSubscriptionWebviewComponent,
      },
      {
        path: 'contact-subscription',
        component: GdoContactSubscriptionWebviewComponent,
      },
      {
        path: 'billing-history',
        component: GdoBillingHistoryWebviewComponent,
      },
      {
        path: 'addNewPaymentOption',
        component: GdoAddNewPaymentOptionsComponent,
      },
      {
        path: 'braintreeUiDropIn',
        component: GdoBraintreeIntegrationComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GdoWebviewRoutingModule {}
